<template>
    <div class="my-5 py-5">
        <v-row v-if="invoice.seller_bank_1" class="pl-3" align="baseline" justify="start" no-gutters>
            <v-col cols="6" class="pb-0">
                {{ invoice.seller_bank_1 }}
                <div v-if="invoice.seller_swift_1" style="line-height: 6px; color: var(--v-g5-base);">
                    <span class="caption py-0 my-0 ">{{ invoice.seller_swift_1 }}</span>
                </div>
            </v-col>
            <v-col cols="6" class="px-3 no-break pb-0">{{ invoice.seller_iban_1 }}</v-col>
        </v-row>
        <v-row v-if="invoice.seller_bank_2" class="pl-3" align="baseline" justify="start" no-gutters>
            <v-col cols="6" class="pb-0">
                {{ invoice.seller_bank_2 }}
                <div v-if="invoice.seller_swift_2" style="line-height: 6px; color: var(--v-g5-base);">
                    <span class="caption py-0 my-0 ">{{ invoice.seller_swift_2 }}</span>
                </div>
            </v-col>
            <v-col cols="6" class="px-3 no-break pb-0">{{ invoice.seller_iban_2 }}</v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "InvoiceBankAccounts",
    components: {},
    props: {
        invoice: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {};
    }
};
</script>
